import { type FetchResult, useMutation } from "@apollo/client";

import { ADD_NODE } from "./../../../common/operations/mutations";
import type {
  AddNodeMutation,
  AddNodeMutationVariables,
  AddNodeInput,
} from "./../../../API";

interface CreateNodeInterface {
  createNode: (input: AddNodeInput) => Promise<FetchResult<AddNodeMutation>>;
  data?: AddNodeMutation | null;
  loading: boolean;
}

export const useCreateNode = (): CreateNodeInterface => {
  const [saveNode, { data, loading }] = useMutation<
    AddNodeMutation,
    AddNodeMutationVariables
  >(ADD_NODE);

  const createNode = async (
    input: AddNodeInput
  ): Promise<FetchResult<AddNodeMutation>> => {
    return await saveNode({
      variables: {
        input,
      },
      update(cache, response): void {
        if (response.data?.addNode) {
          cache.evict({ id: "ROOT_QUERY", fieldName: "getNodes" });

          cache.gc();
        }
      },
    });
  };

  return { createNode, data, loading };
};
